import { renderRequiredRule } from "@/utils/renderRulesForm";

export default (payment) => ({
  whoPaysForCargoPickup: [
    renderRequiredRule("Пожалуйста выберите платильщика"),
    {
      validator: (rule, value, callback) => {
        if (payment.whoPaysForCargoPickup && value === "") {
          callback(new Error("Пожалуйста выберите платильщика"));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
  typeOfPaymentForCargoPickup: [
    renderRequiredRule("Пожалуйста выберите способ оплаты"),
    {
      validator: (rule, value, callback) => {
        if (payment.typeOfPaymentForCargoPickup && value === "") {
          callback(new Error("Пожалуйста выберите способ оплаты"));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
  whoPaysForCargoTransportation: [
    renderRequiredRule("Пожалуйста выберите платильщика"),
    {
      validator: (rule, value, callback) => {
        if (payment.whoPaysForCargoTransportation && value === "") {
          callback(new Error("Пожалуйста выберите платильщика"));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
  typeOfPaymentForCargoTransportation: [
    renderRequiredRule("Пожалуйста выберите способ оплаты"),
    {
      validator: (rule, value, callback) => {
        if (payment.typeOfPaymentForCargoTransportation && value === "") {
          callback(new Error("Пожалуйста выберите способ оплаты"));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
  whoPaysForCargoDelivery: [
    renderRequiredRule("Пожалуйста выберите платильщика"),
    {
      validator: (rule, value, callback) => {
        if (payment.whoPaysForCargoDelivery && value === "") {
          callback(new Error("Пожалуйста выберите платильщика"));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
  typeOfPaymentForCargoDelivery: [
    renderRequiredRule("Пожалуйста выберите способ оплаты"),
    {
      validator: (rule, value, callback) => {
        if (payment.typeOfPaymentForCargoDelivery && value === "") {
          callback(new Error("Пожалуйста выберите способ оплаты"));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
  whoPaysForCargoExtraPacking: [
    renderRequiredRule("Пожалуйста выберите платильщика"),
    {
      validator: (rule, value, callback) => {
        if (payment.whoPaysForCargoExtraPacking && value === "") {
          callback(new Error("Пожалуйста выберите платильщика"));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
  typeOfPaymentForCargoExtraPacking: [
    renderRequiredRule("Пожалуйста выберите способ оплаты"),
    {
      validator: (rule, value, callback) => {
        if (payment.typeOfPaymentForCargoExtraPacking && value === "") {
          callback(new Error("Пожалуйста выберите способ оплаты"));
        }
        callback();
      },
      trigger: "blur",
    },
  ],

  isAgreeDataProcessing: [renderRequiredRule("")],
  isAgreeEmailMailing: [],
});
// {
//   validator: (rule, value, callback) => {
//     if (services.dataForTheDriver && value === "") {
//       callback(new Error("Пожалуйста выберите способ"));
//     }
//     callback();
//   },
//   trigger: "blur",
// },
